import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { PeriodicReportConfig } from 'src/app/models/turns-models/periodic-report.model';
import { PERIODIC_REPORT_LANGUAGES } from 'src/app/models/turns-models/periodic-report-languages';
import { PeriodicReportsTurnsService } from 'src/app/services/turns-services/periodic-reports-turns-service/periodic-reports-turns.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-turns-reports-periodic-configs-dashboard',
  templateUrl: './turns-reports-periodic-configs-dashboard.component.html',
  styleUrls: ['./turns-reports-periodic-configs-dashboard.component.scss']
})
export class TurnsReportsPeriodicConfigsDashboardComponent implements OnInit {
  configs: PeriodicReportConfig[] = [];
  loading = true;
  busyId: string;
  filterText = '';

  constructor(private service: PeriodicReportsTurnsService,
              private breadcrumb: HeaderBreadcrumbService,
              private snack: SnackBarService,
              private translate: TranslateService,
              private dialog: MatDialog,
              private router: Router) { }

  ngOnInit() {
    this.breadcrumb.setRoutes(new Breadcrumb('fas fa-cog', 'turns-periodic.configurations', '/turns/reports/periodic', [
      new BRoute('turns-page.turns', '/turns'),
      new BRoute('turns-page.turns reports', '/turns/reports'),
      new BRoute('turns-periodic.title', '/turns/reports/periodic'),
      new BRoute('turns-periodic.configurations')
    ]));
    this.reload();
  }

  reload() {
    this.loading = true;
    this.service.configs().subscribe(
      configs => {
        this.configs = (configs || []).slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        this.loading = false;
      },
      error => { this.loading = false; this.showError(error); }
    );
  }

  toggle(config: PeriodicReportConfig) {
    if (this.busyId) { return; }
    this.busyId = config.internalId;
    this.service.active(config.internalId, !config.active).subscribe(
      updated => {
        config.active = updated.active;
        this.busyId = null;
        this.snack.open(this.translate.instant('turns-periodic.saved'), 'success');
      },
      error => { this.busyId = null; this.showError(error); }
    );
  }

  generate(config: PeriodicReportConfig) {
    if (this.busyId) { return; }
    this.busyId = config.internalId;
    this.service.generate(config.internalId).subscribe(
      () => {
        this.busyId = null;
        this.snack.open(this.translate.instant('turns-periodic.generated success'), 'success');
        this.router.navigate(['/turns/reports/periodic']);
      },
      error => { this.busyId = null; this.showError(error); }
    );
  }

  deleteConfig(config: PeriodicReportConfig) {
    if (this.busyId) { return; }
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['turns-periodic.delete warning']
      }
    });
    dialogRef.afterClosed().subscribe(accepted => {
      if (!accepted || this.busyId) { return; }
      this.busyId = config.internalId;
      this.service.deleteConfig(config.internalId).subscribe(
        () => {
          this.busyId = null;
          this.snack.open(this.translate.instant('turns-periodic.deleted'), 'success');
          this.reload();
        },
        error => { this.busyId = null; this.showError(error); }
      );
    });
  }

  centers(config: PeriodicReportConfig) {
    return (config.centers || []).map(center => center.name).join(', ');
  }

  languageName(locale: string): string {
    const language = PERIODIC_REPORT_LANGUAGES.find(item => item.locale === locale);
    return language ? language.name : locale || '-';
  }

  get filteredConfigs() {
    const query = this.filterText.trim().toLowerCase();
    return query ? this.configs.filter(config =>
      (config.name || '').toLowerCase().indexOf(query) !== -1 ||
      this.centers(config).toLowerCase().indexOf(query) !== -1) : this.configs;
  }

  private showError(error: any) {
    this.snack.open(error.error && error.error.message || error.message, 'error');
  }
}
